import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  FormGroup,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import moment from "moment";
import DatePicker from "@hassanmojab/react-modern-calendar-datepicker";

export default function FilterModal(props) {
  return (
    <Modal isOpen={props.showModal} size="lg">
      <ModalHeader>{props.title}</ModalHeader>
      <ModalBody>
        <Row>
          <Col lg={12}>
            <h2>Filter by Users</h2>
          </Col>
          <Col lg={6}>
            <FormGroup>
              <label className="form-control-label" htmlFor={`input-feetype`}>
                From
              </label>
              <Input
                type="text"
                value={props.from}
                onChange={(e) => {
                  props.setFrom(e.target.value);
                  props.query.append("from", e.target.value);
                }}
              ></Input>
            </FormGroup>
          </Col>
          <Col lg={6}>
            <FormGroup>
              <label className="form-control-label" htmlFor={`input-feetype`}>
                To
              </label>
              <Input
                type="text"
                value={props.to}
                onChange={(e) => {
                  props.setTo(e.target.value);
                  props.query.append("to", e.target.value);
                }}
              ></Input>
            </FormGroup>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col lg={12}>
            <h2>Filter by Date</h2>
          </Col>
          <Col lg={6}>
            <FormGroup>
              <label className="form-control-label" htmlFor={`input-feetype`}>
                From
                {props.fromDate ? (
                  <Button
                    color="link"
                    size="sm"
                    onClick={() => props.setFromDate(null)}
                  >
                    Clear
                  </Button>
                ) : (
                  <></>
                )}
              </label>
              <DatePicker
                value={props.fromDate}
                onChange={props.setFromDate}
                shouldHighlightWeekends
                wrapperClassName="form-control"
                inputPlaceholder="From"
                calendarPopperPosition="bottom"
                formatInputText={() =>
                  props.fromDate
                    ? moment(
                        props.fromDate.year +
                          "-" +
                          props.fromDate.month +
                          "-" +
                          props.fromDate.day
                      ).format("yyyy-MM-DD")
                    : ""
                }
              />
            </FormGroup>
          </Col>
          <Col lg={6}>
            <FormGroup>
              <label className="form-control-label" htmlFor={`input-feetype`}>
                To
                {props.toDate ? (
                  <Button
                    color="link"
                    size="sm"
                    onClick={() => props.setToDate(null)}
                  >
                    Clear
                  </Button>
                ) : (
                  <></>
                )}
              </label>
              <DatePicker
                value={props.toDate}
                onChange={props.setToDate}
                shouldHighlightWeekends
                wrapperClassName="form-control"
                inputPlaceholder="To"
                calendarPopperPosition="bottom"
                formatInputText={() =>
                  props.toDate
                    ? moment(
                        props.toDate.year +
                          "-" +
                          props.toDate.month +
                          "-" +
                          props.toDate.day
                      ).format("yyyy-MM-DD")
                    : ""
                }
              />
            </FormGroup>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={() => props.toggleModal(false)}>
          Discard
        </Button>
        <Button
          color="primary"
          type="button"
          disabled={props.loading}
          onClick={() => props.filterItems()}
        >
          Filter
        </Button>
      </ModalFooter>
    </Modal>
  );
}
